// Wind session detail query — polls every 3s. Returns session, cycles,
// latest_cycle, summary, chart_points.
import { useQuery } from "@tanstack/react-query";
import { apiGet } from "@/lib/api-client";
import type { WindSession, WindCycle } from "@/types/api";

export interface WindSummary {
  total_pnl: number;
  total_fees: number;
  win_count: number;
  trade_count: number;
}

export interface WindDetailData {
  session: WindSession;
  cycles: WindCycle[];
  latest_cycle: WindCycle | null;
  summary: WindSummary;
  chart_points?: unknown[];
}

export function useWindDetail(id: string) {
  return useQuery<WindDetailData>({
    queryKey: ["wind-detail", id],
    queryFn: () => apiGet<WindDetailData>(`/wind/${id}/detail`),
    // SSE pushes wind events on session/cycle change; 15s safety net (shorter
    // than others because wind cycles are latency-sensitive for TP/SL checks).
    refetchInterval: 15_000,
    enabled: !!id,
  });
}
